<template>
  <comTable
    @selectedDatafn="selectedDatafn"
    :config="tableConfig"
    :filterForm="filterForm"
    ref="table"
  >
    <template v-slot:leftBten>
      <el-button
        class="feature-item add"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addFn()"
        >新建内容管理</el-button
      >
    </template>
  </comTable>
</template>
<script>
import comTable from "@/components/firTable.vue";
export default {
  components: { comTable },
  data() {
    let maps = {
      0: "待上架",
      1: "已上架",
      "-1": "下架",
    };
    return {
      jump_type: {
        0: '无跳转',
        1: "专题列表",
        2: "大图",
        3: "视频",
        4: "文章",
        5: "链接",
        6: "DP",
        7: "VR",
        8: "互动H5",
      },
      ajaxType: false,
      ajaxType2: false,
      checKData: [],
      filterForm: [
        { prop: "id", label: "内容ID", pl: "请输入内容ID检索" },
        { prop: "title", label: "内容标题", pl: "请输入内容标题检索" },
        { prop: "author", label: "创作者昵称", pl: "请输入创作者昵称检索" },
        { prop: "tags", label: "标签", pl: "请输入标签检索" },
        { prop: "jump_type", label: "跳转类型", pl: "请输入跳转类型检索",type: 'select',
          child: [
            { name: "无跳转", id: "0" },
            { name: "专题列表", id: "1" },
            { name: "大图", id: "2" },
            { name: "视频", id: "3" },
            { name: "文章", id: "4" },
            { name: "链接", id: "5" },
            { name: "DP", id: "6" },
            { name: "VR", id: "7" },
            { name: "互动H5", id: "8" },
          ],
        },
      ],
      tableConfig: {
        url: "getContentList",
        list: [
          { label: "内容ID", prop: "id" },
          {
            label: "展示图",
            prop: "prev_url",
            type: "img",
            clfn: (da) => {
              let da_obj = JSON.parse(JSON.stringify(da))
              if(da_obj.prev_url.indexOf("x-oss-process")!=-1){
                var ad = da_obj.prev_url.split('?')
                da.prev_url = ad[0]
              }

              return da.prev_url
                ? `${da.prev_url}?x-oss-process=image/resize,h_80`
                : "";
            },
          },
          {
            label: "分享图",
            prop: "share_img_url",
            type: "img",
            clfn: (da) => {
              return da.share_img_url
                ? `${da.share_img_url}?x-oss-process=image/resize,h_50`
                : "";
            },
          },
          { label: "标题", prop: "title" },
          { label: "副标题", prop: "sub_title" },
          {
            label: "跳转内容",
            prop: "jump_to",
            type: "html",
            clfn: (da) => {
              if (da.jump_type == 2) {
                return `<img class="tableImg" src="${da.jump_to}">`;
              }
              if (da.jump_type == 3) {
                return `<video class="tableImg" src="${da.jump_to}"></video>`;
              }
              return `<div style="overflow: auto;max-height: 100px;">${da.jump_to || '无'}<div>`;
            },
          },
          {
            label: "跳转类型",
            prop: "jump_type",
            clfn: (da) => {
              return this.jump_type[da.jump_type] || "";
            },
          },
          {
            label: "标签",
            prop: "tags",
            type: "html",
            clfn: (da) => {
              let arr = [];
              try {
                arr = JSON.parse(da.tags);
              } catch (error) {
                console.log(error);
              }
              let str = "";
              arr.map((e) => {
                str += `<span class="tages">${e}</span>`;
              });
              return str;
            },
          },

          {
            label: "上架状态",
            prop: "status",
            clfn: (da) => {
              return maps[da.status] || "";
            },
          },

          { label: "创作者昵称", prop: "author" },
          { label: "关联内容数", prop: "relation_subject_count" },
          { label: "创建时间", prop: "create_at" },
          {
            label: "操作",
            type: "tool",
            btns: [
              {
                label: "查看",
                clickFn: (da) => {
                  this.handleBtn(da, "look");
                },
              },
              {
                label: "编辑",
                clickFn: (da) => {
                  this.handleBtn(da, "edit");
                },
              },
              {
                label: "下架",backLabel:da=>{
                  return da.status == 1 ? '下架': '上架'
                },
                clickFn: this.dgxj,
              },

              {
                label: "删除",
                clickFn: (da) => {
                  this.handleDel(da);
                },
              },
            ],
          },
        ],
        isSelection: false,
        showAllBtn: false,
        allBtn: [
          {
            label: "取消操作",
            clickFn: () => {
              this.tableConfig.isSelection = false;
              this.tableConfig.showAllBtn = false;
              console.log(1);
            },
          },
          {
            label: "展示下架",
            clickFn: () => {
              this.xjFn(this.checKData);
            },
          },
          {
            label: "删除",
            clickFn: () => {
              if (this.ajaxType) {
                this.$message("正在处理请稍后");
                return;
              }
              let nam = this.checKData.length;
              if (nam == 0) {
                this.$message("请选择要删除的内容");
                return;
              }
              if (nam == 1) {
                nam = "内容删除";
              } else {
                nam = `内容批量删除 已选${nam}条内容`;
              }
              this.$confirm(
                `是否将选中内容删除？<br/>内容删除后，专题列表和展示位内将同步删除`,
                nam,
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                let arr = this.checKData.map((e) => {
                  return e.id;
                });
                this.deltFN({
                  id: arr.join(","),
                });
              });
            },
          },
        ],
      },
    };
  },
  methods: {
    dgxj(da) {
      if(da.status!=1){
        this.deltFN2({
          id:da.id,
          type:'1',
        })
        return
      }
      this.xjFn([da]);
    },
    xjFn(da) {
      if (this.ajaxType2) {
        this.$message("正在处理请稍后");
        return;
      }
      let nam = da.length;
      if (nam == 0) {
        this.$message("请选择要下架的内容");
        return;
      }
      if (nam == 1) {
        nam = `内容下架 ${da[0].title}`;
      } else {
        nam = `内容批量展示下架 已选${nam}条内容`;
      }
      this.$confirm(
        `是否确认将选中内容下架？<br/>内容下架后，所有渠道的展示位专题列表关联的内容均会删除`,
        nam,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        let arr = da.map((e) => {
          return e.id;
        });
        this.deltFN2({
          id: arr.join(","),
        });
      });
    },
    addFn() {
      this.$router.push("/art/item3-addContent?type=add");
    },
    selectedDatafn(da) {
      this.checKData = da;
    },
    handleDel(row) {
      if (this.ajaxType) {
        this.$message("正在处理请稍后");
        return;
      }
      this.$confirm(
        `是否将选中内容删除？<br/>内容删除后，专题列表和展示位内将同步删除`,
        "内容删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.deltFN({
            id: row.id,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deltFN(pr) {
      this.ajaxType = true;
      this.api
        .delContent(pr)
        .then((res) => {
          this.ajaxType = false;
          if (!res) return;
          this.$message.success("删除成功");
          this.$refs.table.getData();
        })
        .catch(() => {
          this.ajaxType = false;
        });
    },
    deltFN2(pr) {
      this.ajaxType2 = true;
      this.api
        .quickerOffContent(pr)
        .then((res) => {
          this.ajaxType2 = false;
          if (!res) return;
          this.$message.success("操作成功");
          this.$refs.table.getData();
        })
        .catch(() => {
          this.ajaxType2 = false;
        });
    },
    handleBtn(item, type) {
       let routeUrl = this.$router.resolve({
          path: "/art/item3-addContent",
          query: {id:item.id,type:type}
     });
     window.open(routeUrl.href, '_blank');
      // this.$router.push(`/art/item3-addContent?id=${item.id}&type=${type}`);
    },
  },
};
</script>
<style lang='scss' scoped>
</style>